// Admin routes for P7-A (BILLING-01/02/03/04/06/07/10, PARTNER-01). Owned by that worker; the router mounts
// whatever this returns under the app shell (before the store-area placeholder), so modules never
// edit router.tsx. Paths follow IA §2.1. The plan-and-billing page itself (/{org}/settings/billing)
// is routed by router.tsx (Phase 4) and owned here through settings/Billing.tsx.
// D-064: the Adyvance Wallet page (/{org}/{store}/wallet, under Adyvance Services) is code-split.
import { createRoute, lazyRouteComponent, type AnyRoute } from "@tanstack/react-router";
import { WalletPage } from "../billing/WalletPage";

const adyWallet = () => import("../billing/AdyWalletPage");

export function walletRoutes(appRoute: AnyRoute): AnyRoute[] {
  return [
    createRoute({
      getParentRoute: () => appRoute,
      path: "/$org/settings/billing/wallet",
      component: WalletPage,
    }),
    createRoute({
      getParentRoute: () => appRoute,
      path: "/$org/$store/wallet",
      component: lazyRouteComponent(adyWallet, "AdyWalletPage"),
    }) as unknown as AnyRoute,
  ];
}
